import TableSkeleton from './table-skeleton';

export default function FavoritePointOfSaleTableSkeleton() {
    const columns = ['Nom', 'Nombre de livraisons', 'Quantité totale'];

    return <TableSkeleton rows={5} columns={columns} />;
}
